import { IDecorate } from './types';
import { AxiosResponse, AxiosError, AxiosRequestConfig } from 'axios';
import Config from '@/config';
import Default from './default';
import GCPService from './gcpService';
import NetworkCheck from './networkCheck';

/*
 * HTTP Decoration class
 * For multiple backends, different config such as headers, different response structures, they are mapped to different decoration classes for processing
 * supports multiple decorators per URL pattern
 */
let HTTP_DECORATE_REGISTER: { [key: string]: (() => IDecorate)[] } = {
  [Config.H5_SERVICE.URL]: [() => new NetworkCheck(), () => new GCPService()],
  [Config.BFF_SERVICE.URL]: [() => new NetworkCheck(), () => new GCPService()],
};
{
  HTTP_DECORATE_REGISTER = { ...HTTP_DECORATE_REGISTER };
}

export default class HttpDecorate {
  decorators: IDecorate[] = [];

  register(url: string) {
    this.decorators = [new Default()];

    for (const key in HTTP_DECORATE_REGISTER) {
      if (url.startsWith(key)) {
        const decoratorFactories = HTTP_DECORATE_REGISTER[key];
        this.decorators = decoratorFactories.map((factory) => factory());
        break;
      }
    }
  }

  async config(config: AxiosRequestConfig) {
    this.register(config.url);

    // Execute config for all decorators
    for (const decorator of this.decorators) {
      await decorator.config?.(config);
    }
  }

  async success(
    result: AxiosResponse,
    request: (config: AxiosRequestConfig) => any,
  ) {
    // Chain success processing
    let processedResult = result;
    for (const decorator of this.decorators) {
      if (decorator.success) {
        processedResult = await decorator.success(processedResult, request);
      }
    }
    return processedResult;
  }

  async error(err: AxiosError, request: (config: AxiosRequestConfig) => any) {
    // Chain error processing
    let processedError = err;

    for (const decorator of this.decorators) {
      if (decorator.error) {
        processedError = await decorator.error(processedError, request);
      }
    }

    return processedError;
  }
}
